import { render, staticRenderFns } from "./createAtendimento.vue?vue&type=template&id=b9e9b4dc&scoped=true"
import script from "./createAtendimento.vue?vue&type=script&lang=js"
export * from "./createAtendimento.vue?vue&type=script&lang=js"
import style0 from "./createAtendimento.vue?vue&type=style&index=0&id=b9e9b4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e9b4dc",
  null
  
)

export default component.exports